import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { StoreGeohash } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class FetchStoreGeohashService extends BaseGetProvider<StoreGeohash> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof StoreGeohash {
    return StoreGeohash;
  }

  get endpoint(): string {
    return this.endpointService.fetchStoreGeohash();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    storeId: number,
  ): {
    store_id: number;
  } {
    const param: {
      store_id: number;
    } = {
      store_id: storeId,
    };

    return param;
  }
}
